import React from 'react';
import "./Bouton.css"

function Bouton(props) {
  const { titre } = props;
  const { onClick } = props;
  const { className =''} = props;

  return (
  <button type="submit" className={`btn-black btn ${className}`} onClick={onClick}>
    {titre}
  </button>
  );
}

export default Bouton;
